(function (Drupal, $) {
  'use strict';

  function matchElements() {
    $('.paragraph--type-text-image-2-col > .group-left, .paragraph--type-text-image-2-col > .group-right').matchHeight({})
    $('.paragraph--type-download-file').matchHeight({ remove: true }).matchHeight({})
    $('.paragraph--type-do-you-know-elem .group-content').matchHeight({ remove: true }).matchHeight({})
    $('.paragraph--type-video > div').matchHeight({ remove: true }).matchHeight({})
    $('.image_title_description_link__image').matchHeight({ remove: true }).matchHeight({})
    $('.image_title_description_link__title').matchHeight({ remove: true }).matchHeight({})
    $('.image_title_description_link__description').matchHeight({ remove: true }).matchHeight({})
    $('.paragraph--type-image-title-description-link').matchHeight({ remove: true }).matchHeight({})
    $('.link_graphical__text').matchHeight({ remove: true }).matchHeight({})
    $('.paragraph--type-award').matchHeight({ remove: true }).matchHeight({})
    $('.node--type-location').matchHeight({ remove: true }).matchHeight({})
    $('.node--type-media').matchHeight({ remove: true }).matchHeight({})
  }

  function graphicalHeaderHelper() {
    $('.paragraph--type-graphical-header').each(function () {
      const $this = $(this)
      const innerHeight = $this.find('.graphical_header__text').height() + 40

      $this.css({
        minHeight: innerHeight
      })
    });

    $('.paragraph--type-graphical-header').each(function () {
      const $this = $(this)
      const innerHeight = $this.find('.group-content').outerHeight() + 60

      $this.css({
        minHeight: innerHeight
      })
    });
  }

  function headerHelper() {
    $('.paragraph--type-header-type-1').each(function () {
      const $this = $(this)
      const innerHeight = $this.find('.group-content').height() + 40

      $this.find('.wrapper').css({minHeight: innerHeight})
    });
  }

  function doYouKnowHelper() {
    $('.paragraph--type-do-you-know-elem').each(function () {
      const $this = $(this)
      const innerHeight = $this.find('.group-content').height() + 60

      $this.css({minHeight: innerHeight})
    });
  }

  function maxWidth () {
    const maxWidth = $('.node--type-dynamic-page.node--view-mode-full').data('max-width')

    if (maxWidth) {
      $('.field-name-field-page-paragraphs').css({maxWidth: maxWidth})
    }
  }

  function galleryHelper () {
    const galleryElem = $('.paragraph--type-gallery-elem')

    galleryElem.each(function (index, elem) {
      const $elem = $(elem)

      if (!$elem.hasClass('processed')) {
        const link_origin = $elem.find('a.colorbox')
        const link = link_origin.clone()
        const image = link_origin.find('img')

        link_origin.replaceWith(image)
        $elem.find('.group-content').append(link.text(''))
        $elem.addClass('processed')
      }
    })
  }

  function businessContacts () {
    if ($('.view-contacts').length > 0) {
      $(document).off('ajaxSuccess.contacts')
        .on('ajaxSuccess.contacts', function() {
          let displayResults = false

          $('.views-exposed-form select').each(function (index, elem) {
            if ($(elem).val() !== 'All') {
              displayResults = true
            }
          })

          if (displayResults) {
            $('.view-contacts ').addClass('show')
          }
          else {
            $('.view-contacts ').removeClass('show')
          }
        })
    }
  }

  function mediaDownload () {
    if ($('.view-media .media-header').length > 0) {
      $('.media-header .title').off('click.media').on('click.media', function () {
        $('body').addClass('display-media')
      })
    }
  }

  $(window).off('resize.dp').on('resize.dp', function () {
    graphicalHeaderHelper()
    headerHelper()
    doYouKnowHelper()
  })

  Drupal.behaviors.dynamic_page = {
    attach: function (context, settings) {
      matchElements()
      graphicalHeaderHelper()
      headerHelper()
      doYouKnowHelper()
      maxWidth()
      galleryHelper()
      businessContacts()
      mediaDownload ()
    }
  }

})(Drupal, jQuery)
